import { useEffect, useRef, useState, useCallback } from 'react';
import { useAppMessage, useActiveParticipant } from '@daily-co/daily-react';
import * as PIXI from 'pixi.js';
import { useRecoilState, useRecoilValue } from 'recoil';
import { webcamAtom, reactionAtom, screenShareAtom } from '../../State';
import { Assets } from '@pixi/assets';
import isElectron from '../../Global';
import { getImagePath } from '../Util/utils';

export default async function LoadingModel(loadingRef, containerRef) {
  return new Promise(async function (resolve, reject) {
    if (loadingRef.current != null || containerRef.current == null) {
      return reject(false);
    }

    //アニメーションロード
    // const loader = new PIXI.Loader();
    //let currentResource = loader.resources;

    //キャッシュにある場合
    // if (currentResource['loading'] != undefined) {
    //   loadAnim(currentResource);
    // } else {

    //loader.add('loading', './images/anim/loading/loading.json');
    //return loader.load((_, resources) => {
    var sheet = [];
    let loadURL;
    // if (isElectron) {
    //   loadURL = './images/anim/loading/loading.json';
    // } else {
    //   loadURL = './images/anim/loading/loading.json';
    // }

    loadURL = getImagePath() + '/anim/loading/loading.json';
    const texture = await Assets.load(loadURL);
    //テクスチャを配列に入れる
    let obj = texture.textures; //resources.loading.textures;
    Object.keys(obj).forEach(function (key) {
      sheet.push(obj[key]);
    });

    if (loadingRef.current == null) {
      loadingRef.current = new PIXI.AnimatedSprite(sheet);
      loadingRef.current.animationSpeed = 0.5;
      loadingRef.current.play();

      //anim.loop = false;

      loadingRef.current.anchor.set(0.5);
      loadingRef.current.scale.set(0);

      //ステージに追加
      containerRef.current.addChild(loadingRef.current);
      loadingRef.current.zIndex = -1;
      loadingRef.current.visible = true;
    }

    return resolve(true);
  });
}
